import { render, staticRenderFns } from "./agenda-geral-profissional.vue?vue&type=template&id=6fc70664&"
import script from "./agenda-geral-profissional.vue?vue&type=script&lang=js&"
export * from "./agenda-geral-profissional.vue?vue&type=script&lang=js&"
import style0 from "./agenda-geral-profissional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports